import React, { useState } from 'react';
import styled from 'styled-components';
import Img from 'gatsby-image';
import { Link } from 'gatsby';

const CategoryCardStyled = styled.div`
  background: var(--white);
  border: 1px solid var(--blackMatte);
  color: var(--blackMatte);
  display: flex;
  flex-direction: column;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.2);
  border-radius: 8px;
  overflow: hidden;
  width: 100%;
  text-align: left !important;
  a {
    color: var(--borderColor);
    text-decoration: none;
  }
  a:hover {
    cursor: pointer;
  }
  .product-image {
    display: grid;
    align-items: center;
    justify-items: center;
    height: auto;
    width: 100%;
  }
  .category {
    padding: 1.5rem;
  }
  h4,
  .product-explore {
    padding: 1.5rem 1.5rem 1.5rem 0;
    margin-left: 1.5rem;
    margin-top: 1.5rem;
    border-top: 1px solid var(--blackMatte);
  }
  .product-explore {
    margin-top: auto;
  }
  .product-excerpt {
    padding: 0 1.5rem 1.5rem 0;
    margin-left: 1.5rem;
    max-height: 80px;
    overflow: hidden;
    box-sizing: content-box;
  }
  .category {
    border-top: 1px solid var(--blackMatte);
    display: block;
    text-transform: uppercase;
  }
`;

export default function CategoryCard(props) {
  return (
    <CategoryCardStyled>
      <Link to={`/category/${props.slug}`}>
        <Img
          fluid={props.image}
          alt={props.title}
          className="product-image"
          imgStyle={{ objectFit: 'contain' }}
          aspectRatio={5 / 3}
        />
      </Link>
      <h4>{props.title}</h4>
      <div className="product-explore">
        <Link to={`/category/${props.slug}`}>Explore {props.title}</Link>
      </div>
    </CategoryCardStyled>
  );
}
